import React, { Component } from 'react';
import './Footer.css';
import { PROPERTIES } from '../../constants/config';
import { Link } from 'react-router-dom'; // Add this

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();
    return (
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            {'\u00A9'} {currentYear} {PROPERTIES.COMPANY_NAME}
          </div>
          <div className="footer-right">
            <Link to="/privacy-policy" className="footer-link">
              Privacy Policy
            </Link>
            <span className="footer-separator">|</span>
            <Link to="/terms-and-conditions" className="footer-link">
              Terms & Conditions
            </Link>
            <span className="footer-separator">|</span>
            <Link to="/sms-opt-in" className="footer-link">
              SMS Opt-In
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
